import React from 'react';
import {
  TruckIcon,
  ShieldCheckIcon,
  ClockIcon,
  CurrencyDollarIcon,
} from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';

const BenefitsSection: React.FC = () => {
  const { t } = useTranslation();

  const benefits = [
    {
      icon: <TruckIcon className='h-10 w-10 text-primary' />,
      title: t('benefits.fastDelivery'),
      description: t('benefits.fastDeliveryDesc'),
    },
    {
      icon: <ShieldCheckIcon className='h-10 w-10 text-primary' />,
      title: t('benefits.freshFruits'),
      description: t('benefits.freshFruitsDesc'),
    },
    {
      icon: <CurrencyDollarIcon className='h-10 w-10 text-primary' />,
      title: t('benefits.fruitWarranty'),
      description: t('benefits.fruitWarrantyDesc'),
    },
    {
      icon: <ClockIcon className='h-10 w-10 text-primary' />,
      title: t('benefits.loyaltyProgram'),
      description: t('benefits.loyaltyProgramDesc'),
    },
  ];

  return (
    <section className='py-12'>
      <div className='container mx-auto px-4'>
        <h2 className='text-2xl font-bold text-gray-800 mb-10 text-center'>
          {t('benefits.title')}
        </h2>
        <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8'>
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className='text-center p-6 rounded-lg border border-gray-100 hover:shadow-md transition-shadow duration-300'
            >
              <div className='inline-flex items-center justify-center mb-4'>
                {benefit.icon}
              </div>
              <h3 className='text-lg font-semibold mb-2'>{benefit.title}</h3>
              <p className='text-gray-600 whitespace-pre-line'>
                {benefit.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;
